module.exports = __webpack_public_path__ + "static/media/destaque-admin.498b2376.png";